<template>
    <playerList :type="'player_data'"></playerList>
</template>

<script>
import playerList from "@/components/newPlayerList";
export default {
    name: "player_data",
    components:{
        playerList
    }
}
</script>
